export enum FACT_NAMES_NUMERIC {
  YEARS_IN_BUSINESS = "YEARS_IN_BUSINESS",
  BANK_BALANCE_PER_TRUCK = "BANK_BALANCE_PER_TRUCK",
  NUMBER_OF_TRUCKS = "NUMBER_OF_TRUCKS",
  PERSONAL_CREDIT_SCORE = "PERSONAL_CREDIT_SCORE",
  INDUSTRY_EXPERIENCE_YEARS = "INDUSTRY_EXPERIENCE_YEARS",
  EQUIPMENT_AGE = "EQUIPMENT_AGE",
  AVERAGE_BANK_BALANCE = "AVERAGE_BANK_BALANCE",
  EQUIPMENT_MODEL_YEAR = "EQUIPMENT_MODEL_YEAR",
  FLEET_SIZE = "FLEET_SIZE",
}
